import React, { useState } from 'react'
import { withRouter } from 'react-router'
import { Box, Typography } from '@mui/material'
import { Header, Dropdown, SwitchPersona } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { useIsSmallScreen, useUserInfo } from 'packages/core'
import useConfiguration from 'useConfiguration'
import { useTranslation } from 'react-i18next'
import { useCurrentPerson, useTargetPerson } from 'hooks'
import appConfig from 'config'
import useSubcomponents from 'useSubcomponents'

const useAccess = () => {
    const { resourceTypes } = useConfiguration()
    const {
        canShopForOthers,
        hasAccessToApplicationProcesses,
        hasAccessToBusinessDomains,
        hasAccessToTargetSystemControl,
    } = useSubcomponents()

    const hasAccessToAnyResource = resourceTypes.length > 0

    const hasAccessToGuideShop =
        hasAccessToAnyResource &&
        (canShopForOthers ||
            hasAccessToApplicationProcesses ||
            hasAccessToBusinessDomains ||
            hasAccessToTargetSystemControl)

    return {
        hasAccessToGuideShop,
        canShopForOthers,
        hasAccessToApplicationProcesses,
        hasAccessToBusinessDomains,
        hasAccessToTargetSystemControl,
    }
}

const AccountDropdown = ({ history }) => {
    const isSmallScreen = useIsSmallScreen()
    const {
        hasAccessToGuideShop,
        canShopForOthers,
        hasAccessToApplicationProcesses,
        hasAccessToBusinessDomains,
        hasAccessToTargetSystemControl,
    } = useAccess()
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)

    const { data: userInfo } = useUserInfo()
    const { data: personData } = useCurrentPerson()
    const [, , { deleteSavedTargetPersonId }] = useTargetPerson()
    const { hasAccessToTabs } = useSubcomponents()

    const { manageAccess, resourceTypes } = useConfiguration(history)

    const renderManageAccessMenuItem = (item) => {
        return (
            <>
                <Dropdown.Item
                    tabIndex={0}
                    onClick={(e) => {
                        const manageAccessRoute = `${appConfig.APP_SUBPATH}${resourceTypes[0].route}${manageAccess.route}`
                        history.push(manageAccessRoute)
                        setOpen((prev) => !prev)
                    }}
                >
                    <Icon name={item.icon.small} color="#919193" />
                    {t(item.title)}
                </Dropdown.Item>
            </>
        )
    }

    const renderResourceTypeMenuItem = (resourceType) => {
        const { hasAccessToRequestAccess } = hasAccessToTabs(resourceType.name)
        return (
            hasAccessToRequestAccess && (
                <Dropdown.Item
                    tabIndex={0}
                    key={resourceType.name}
                    onClick={(e) => {
                        history.push(
                            `${appConfig.APP_SUBPATH}${resourceType.route}`,
                        )
                        setOpen((prev) => !prev)
                    }}
                    sx={{
                        '&:hover, &:focus': {
                            backgroundColor: '#f5f5f7 !important',
                        },
                    }}
                >
                    <Icon
                        name={resourceType.icon.small}
                        id={`${resourceType.icon.small}-header`}
                        color="#919193"
                    />
                    {t(resourceType.title)}
                </Dropdown.Item>
            )
        )
    }

    const content = (
        <>
            {manageAccess && renderManageAccessMenuItem(manageAccess)}
            <Box
                sx={{
                    marginLeft: '1.6rem',
                    borderBottom: 'solid 1px #f5f5f7',
                    marginBottom: '1rem',
                    marginTop: '1rem',
                }}
            >
                <Typography
                    style={{
                        fontSize: '1.1rem',
                        padding: '0.4rem 1rem',
                        textTransform: 'uppercase',
                        backgroundColor: '#767474',
                        display: 'inline-block',
                        borderTopLeftRadius: '.6rem',
                        borderTopRightRadius: '.6rem',
                        color: '#fff',
                        fontWeight: '500',
                    }}
                >
                    {t('Common_RequestAccess')}
                </Typography>
            </Box>

            {resourceTypes.map((item) => renderResourceTypeMenuItem(item))}

            {hasAccessToGuideShop && (
                <>
                    <Box
                        data-protectedsubcomponent={`${canShopForOthers} OR ${hasAccessToApplicationProcesses} OR ${hasAccessToBusinessDomains} OR ${hasAccessToTargetSystemControl}`}
                        sx={{
                            marginLeft: '1.6rem',
                            borderBottom: 'solid 1px #f5f5f7',
                            marginBottom: '1rem',
                            marginTop: '1rem',
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: '1.1rem',
                                padding: '0.4rem 1rem',
                                textTransform: 'uppercase',
                                backgroundColor: '#767474',
                                display: 'inline-block',
                                borderTopLeftRadius: '.6rem',
                                borderTopRightRadius: '.6rem',
                                color: '#fff',
                                fontWeight: '500',
                            }}
                        >
                            {t('OnBoarding_Guide')}
                        </Typography>
                    </Box>
                    <Dropdown.Item
                        tabIndex={0}
                        data-protectedsubcomponent={`${canShopForOthers} OR ${hasAccessToApplicationProcesses} OR ${hasAccessToBusinessDomains} OR ${hasAccessToTargetSystemControl}`}
                        onClick={(e) => {
                            history.push(`${appConfig.APP_SUBPATH}/guidedShop`)
                            setOpen((prev) => !prev)
                        }}
                        sx={{
                            '&:hover, &:focus': {
                                backgroundColor: '#f5f5f7 !important',
                            },
                        }}
                    >
                        <Icon name="HelpWheel" color="#919193" />
                        {t('OnBoarding_GuidedShop')}
                    </Dropdown.Item>
                </>
            )}

            {/* Login As / Switch Persona */}
            <SwitchPersona
                apiUrl={appConfig.API_URL}
                baseEidUrl={appConfig.BASE_EID_URL}
                actPersonId={userInfo?.actPersonId}
                personId={userInfo?.id}
            />

            {/*<Typography
                style={{
                    color: '#ced1d4',
                    fontSize: '11px',
                    paddingLeft: '16px',
                    textTransform: 'uppercase',
                }}
            >
                ASSIGN AS
            </Typography>
            <Dropdown.Item
                onClick={(e) => {
                    history.push('/cloneAccess')
                }}
            >
                <Icon name="CloneAccess" />
                Clone Access
            </Dropdown.Item>

            <Divider
                style={{
                    marginTop: '10px',
                    marginBottom: '10px',
                }}
                variant="middle"
            />
        */}

            <Dropdown.Item
                tabIndex={0}
                onClick={() => {
                    deleteSavedTargetPersonId()
                    history.push('/signout')
                    setOpen((prev) => !prev)
                }}
                sx={{
                    '&:hover, &:focus': {
                        backgroundColor: '#f5f5f7 !important',
                    },
                }}
            >
                <Icon name="LogOut" color="#919193" />
                {t('Common_SignOut')}
            </Dropdown.Item>
        </>
    )

    const imageUrl = `${appConfig.BASE_EID_URL}${personData?.imageThumbUrl}`

    const scrollableContent = (
        <Box
            sx={{
                maxHeight: 'calc(98vh - 14rem)',
                overflowY: 'auto',
                overflowX: 'hidden',
                '@media (max-height: 640px)': {
                    maxHeight: 'calc(90vh - 17rem)',
                },
            }}
        >
            {content}
        </Box>
    )

    const mobile = (
        <Header.AccountDropdown
            imageUrl={imageUrl}
            anchorPosition={{ right: '-32px' }}
            friendlyName={personData?.friendlyName}
            showCone={false}
            open={open}
            handleOpen={setOpen}
        >
            {scrollableContent}
        </Header.AccountDropdown>
    )

    const desktop = (
        <Header.AccountDropdown
            imageUrl={imageUrl}
            open={open}
            handleOpen={setOpen}
            friendlyName={personData?.friendlyName}
        >
            {scrollableContent}
        </Header.AccountDropdown>
    )

    return isSmallScreen ? mobile : desktop
}

export default withRouter(AccountDropdown)
